import { IntlMessageId } from 'locale';
import { PagePathname } from 'utils/hooks/navigation/types';
import { PermissionName } from '@utmost.co/enterprise-models';
import { bpeConfig } from '@enterprise/common';

const root = '/:tenantCode/time-and-expenses';

export const timeAndExpensesConfig = {
  title: 'navmenu.timeAndExpenses.link' as IntlMessageId,
  stateId: 'timeAndExpenses',
  id: 'time-and-expenses',
  featureName: 'time-and-expenses-hub',
  permissionName: 'TIMESHEET' as PermissionName,
  paths: {
    root,
    timesheets: `${root}/timesheets/:timesheetUid?`,
    timesheetsNoRoot: `/timesheets/:timesheetUid?` as PagePathname,
    expenses: `${root}/expenses`,
    expensesNoRoot: `/expenses`
  },
  destination: {
    root: () => root.replace(':tenantCode', bpeConfig.tenant.code ?? '')
  }
} as const;

export default timeAndExpensesConfig;
